import classNames from 'classnames';
import React from 'react';
import { convertPx } from '../../utils/convert-px';
import { withNativeProps } from '../../utils/native-props';
import { withDefaultProps } from '../../utils/with-default-props';
var classPrefix = "adm-progress-bar";
export var ProgressBar = withDefaultProps({
  percent: 0,
  strokeColor: '#1677FF'
})(function (props) {
  var strokeWidth = props.strokeWidth;

  if (strokeWidth === undefined) {
    strokeWidth = convertPx(3);
  }

  var trailStyle = {
    height: strokeWidth + "px",
    borderRadius: strokeWidth / 2 + "px",
    background: '#e5e5e5'
  };
  var pathStyle = {
    height: strokeWidth + "px",
    borderRadius: strokeWidth / 2 + "px",
    width: props.percent + "%",
    background: props.strokeColor,
    transition: 'width 0.3s'
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-trail",
    style: trailStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(classPrefix + "-path"),
    style: pathStyle
  }))));
});